const FooterBottom = () => {
    return (
        <div className="footer-bottom">
            <div className="container">
                <div className="row">
                    <div className="text-center copyright">
                        <p>
                            Copyright &copy; <a href="https://factbazaar.com/">Factbazaar</a>. All Rights Reserved
                        </p>
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

export default FooterBottom;
